import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-team" }
const _hoisted_2 = { class: "as-team__head" }
const _hoisted_3 = { class: "as-team-head__img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "as-team-head__info" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "as-team__performance" }
const _hoisted_8 = {
  key: 0,
  class: "as-scores"
}
const _hoisted_9 = { class: "as-score as-ppg" }
const _hoisted_10 = {
  key: 0,
  class: "as-scores"
}
const _hoisted_11 = { class: "as-score as-ppg" }
const _hoisted_12 = {
  key: 0,
  class: "as-scores"
}
const _hoisted_13 = { class: "as-score as-ppg" }

import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { getImageUrl } from '~src/helpers/footystats';
    import { ref, computed, getCurrentInstance } from 'vue';

    
const __default__ = {};

interface Props {
        footyStats: IFootyStats | null;
        teamMode?: string;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TeamItem',
  props: {
    footyStats: { default: null },
    teamMode: { default: 'home' },
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const iTeam = ref<ITeam | null>(null)
    const props = __props


    const formRunOverall = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_overall){
            const formRunString = _formRun.stats.additional_info.formRun_overall.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const formRunHome = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_home){
            const formRunString = _formRun.stats.additional_info.formRun_home.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const formRunAway = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_away){
            const formRunString = _formRun.stats.additional_info.formRun_away.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const getImageCountry = () => {
        const instance: any = getCurrentInstance();
        const __data: ITeam | null = props.teamMode === 'home' ? props.homeTeamInfo : props.awayTeamInfo;
        if(!__data?.mappingCountry){
            return '';
        }

        return __data.mappingCountry.thesports_id?  instance.proxy?.getImgUrlBySport('country', __data.mappingCountry.thesports_id) : '';
    }

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts') => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode];
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(getImageUrl)(`${_ctx.teamMode == 'away' ? _ctx.footyStats?.away_image : _ctx.footyStats?.home_image}`)
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          (getImageCountry())
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: getImageCountry()
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.teamMode == 'away' ? _ctx.awayTeamInfo?.full_name : _ctx.homeTeamInfo?.full_name), 1)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.teamMode == 'away' ? _ctx.awayTeamInfo?.country : _ctx.homeTeamInfo?.country) + _toDisplayString(_ctx.footyStats?.season_data.name ? ` - ${_ctx.footyStats?.season_data.name}` : ''), 1),
        _createElementVNode("div", null, " Gần đây: " + _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonWinsNum_overall')) + " Thắng | " + _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonDrawsNum_overall')) + " Hòa | " + _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonLossesNum_overall')) + " Thua ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", null, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Phong độ"),
            _createElementVNode("th", null, "Kết quả"),
            _createElementVNode("th", null, "PPG")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("td", null, "Tổng quan", -1)),
            _createElementVNode("td", null, [
              (formRunOverall.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formRunOverall.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(`as-score as-${item.toUpperCase()}`),
                        key: index
                      }, _toDisplayString(item.toUpperCase()), 3))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.teamMode === 'home' ? _ctx.footyStats?.pre_match_teamA_overall_ppg :  _ctx.footyStats?.pre_match_teamB_overall_ppg), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[1] || (_cache[1] = _createElementVNode("td", null, "Đội nhà", -1)),
            _createElementVNode("td", null, [
              (formRunHome.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formRunHome.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(`as-score as-${item.toUpperCase()}`),
                        key: index
                      }, _toDisplayString(item.toUpperCase()), 3))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.teamMode === 'home' ? _ctx.footyStats?.home_ppg :  _ctx.footyStats?.away_ppg), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("td", null, "Đội khách", -1)),
            _createElementVNode("td", null, [
              (formRunAway.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formRunAway.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(`as-score as-${item.toUpperCase()}`),
                        key: index
                      }, _toDisplayString(item.toUpperCase()), 3))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.teamMode === 'home' ? _ctx.footyStats?.pre_match_home_ppg :  _ctx.footyStats?.pre_match_away_ppg), 1)
            ])
          ])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-team__statics" }, null, -1))
  ]))
}
}

})